import { EUnitRole } from './units.interfaces';

// ---------------------------------------------
// variables

export enum ESocietyBoardRole {
  President = 'president',
  VicePresident = 'vicepresident',
  Treasury = 'treasury',
  Member = 'member',
  Secretary = 'secretary',
  Alternate = 'alternate',
  Advisor = 'advisor',
  NominatingCommittee = 'nominating-committee',
}

export enum ESocietyAdminRole {
  None = '',
}


export interface IPreApprovedList {
    _id: string;
    unitId?: string;
    // LEGACY: We now always have either an unit id or address id, user can no longer
    //         input the unit title -- js, 27/08/2021
    unitTitle?: string;
    userEmail: string;
    role?: EUnitRole;
    adminRole?: ESocietyAdminRole;
    boardRole?: ESocietyBoardRole;
}

export interface IActivatedPartnerData {
    partnerId: string;
    boardFolderSructureCreated?: boolean;
    societyFolderSructureCreated?: boolean;
  };

export interface IBoardMember {
    userId: string;
    role: ESocietyBoardRole;
};

export interface ISocietiesCreate {
  // basic
  status?: 'inactive' | 'active';
  accountType?: 'basic' | 'premium';
  accountTypeChangeDate?: Date;
  lastInvoiceDate?: Date;
  name: string;
  organisationNumber?: string;

  addressCo?: string;
  addressStreet?: string;
  addressZip?: string;
  addressCity?: string;
  addressCounty?: string;
  addressMunicipality?: string;
  addressCountryCode?: string;
  addressLat?: number;
  addressLng?: number;

  // general data
  founded?: Date;
  coverPhotoId?: string;
  description?: string;

  // company related
  companyOrganisationNumber?: string;
  companyName?: string;

  // Type of society sets how the app handles the society
  // and what features will be available. Like is the board
  // active or not.
  typeOfSociety?: 'legal_entity' | 'nonlegal_entity' | 'rented' | 'shared';

  // Society type name sets how the app displays the type when viewed in the app
  // it is only for display purposes as different markets call things differently
  // it does not affect the features
  // it should be a transation string e.g. SOCIETY_TYPE_DISPLAY_NAMES.NEIGHBOURHOOD
  societyTypeDisplayName?:
    | 'housing_cooperative'
    | 'housing_cooperative_construction'
    | 'homeowners_association'
    | 'non_profit_association'
    | 'economic_association'
    | 'neighbourhood'
    | 'apartment_building'
    | 'boat_club'
    | 'shared';

  // billing data
  billingCompany?: string;
  billingEmail?: string;
  billingEmailCC?: string[];
  billingOrgNo?: string;
  billingUnits?: number;

  // billing address
  addressBillingCo?: string;
  addressBillingStreet?: string;
  addressBillingZip?: string;
  addressBillingCity?: string;
  addressBillingCounty?: string;
  addressBillingMunicipality?: string;
  addressBillingCountryCode?: string;
  addressBillingLat?: number;
  addressBillingLng?: number;

  // User links
  masterAdminUserId?: string;
  boardMembersList?: IBoardMember[];
  adminsList?: {
    userId: string;
    role: ESocietyAdminRole;
  }[];
  nominatingCommitteeList?: {
    userId: string;
  }[];
  blockList?: {
    userId: string;
  }[];

  preApprovedList?: IPreApprovedList[];

  reportProblemEmailCC?: string[];

  // list of groups included under this society
  groupsList?: {
    groupId: string;
  }[];

  documentsRootFolderId?: string;
  boardDocumentsRootFolderId?: string;

  // ----------------------------------------------------------------
  // Settings related

  // Track which society widgets are hidden
  hiddenSocietyWidgets?: string[];

  // TODO: need to decide upon one! right now these are both in use, -- js, 30-12-2020
  residentsCanPost?: boolean;
  residentPostingDisabledByAdmin?: boolean;

  settings?: {
    // Track which society widgets are hidden
    widgetsDisabled?: string[];
    residentPostingDisabled?: boolean;
    marketplacePostingDisabled?: boolean;
    chatBoardDisabled?: boolean;
    chatOneOnOneDisabled?: boolean;
    chatInterestsDisabled?: boolean;
    chatQuestionsDisabled?: boolean;
    chatAskBoardDisabled?: boolean;
    chatAskBoardDisabledResidentMessage?: string;
  };

  // ----------------------------------------------------------------
  // Developer related

  developerName?: string;
  developerThemingActive?: boolean;

  // ----------------------------------------------------------------
  // Society Facilities - Array of facilities that belong to this society
  // DEV NOTE: facilityList is currently not being used. The relationship is
  // set in the facility resource (facility.societyId)

  // facilityList: [{
  //   facilityId: { type: String },
  // }],
  // ----------------------------------------------------------------

  // Society Widgets - Array of society widgets that belong to this society
  societyWidgetsList?: {
    societyWidgetId: string;
  }[];

  // Bostore settings
  bostore?: {
    guestit?: {
      enabled?: boolean;
      formFilled?: boolean;
    };
  };

  activatedPartnerData?: IActivatedPartnerData[];
  trialPeriodEndDate?: string | Date;
}

export interface ISocietiesModel extends ISocietiesCreate {
  _id: string;
  createdAt: string;
  updatedAt: string;

  activatedAt: string;
  discount?: {
    code: string;
    createdAt?: string | Date;
  } | null;
  locked?: boolean;
}

export interface ISocietyIdUser {
  avatarUrl?: string;
  _id: string;
  societyId: string;
  name: string;
  surname: string;
  fullName: string;
  unitString: string;
}

export interface ISocietyUser {
  avatarUrl?: string;
  _id: string;
  name: string;
  surname: string;
  fullName: string;
  unitString: string;
  chatId: string;
  societyIds: string[];
  email?: string;
}
